import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import {
  DocumentViewerSingletonExtraction,
  FocusedExtraction,
} from 'dashboard/redux/reducers/document-viewer-document-generic';
import ExtractionDetail from 'dashboard/views/DashboardDocumentViewerView/ExtractionDetail';
import { Label } from 'design-system/components/Text/Text';
import { paragraphMixins } from 'design-system/mixins/text';

const ExtractionTitleContainer = styled('div')`
  padding: ${Spacing[3]} ${Spacing[5]};
  overflow-wrap: anywhere;
`;

const Container = styled('div')`
  background: white;
  min-width: 300px;
  max-width: 500px;
  width: 100%;
  border-radius: ${({ theme }) => theme.element.borderRadius};
  color: black;
  ${paragraphMixins.md}
`;

export interface OverlappingExtractionHoverCardProps {
  extractions: DocumentViewerSingletonExtraction[];
  setFocusedExtractions: (focusedExtractions: FocusedExtraction[]) => void;
}

export const OverlappingExtractionHoverCard = ({
  extractions,
  setFocusedExtractions,
}: OverlappingExtractionHoverCardProps) => {
  return (
    <Container>
      <ExtractionTitleContainer>
        <Label size='md' color='primary'>{`${extractions.length} extractions`}</Label>
      </ExtractionTitleContainer>
      {extractions.map((extraction) => {
        const extractionGroup = extraction.extractionGroup;
        return (
          <ExtractionDetail
            key={`${extractionGroup.fieldName}-${extractionGroup.extractionValue}`}
            extractionGroup={extractionGroup}
            handleClick={() => {
              setFocusedExtractions([
                {
                  extractionGroup: extraction.extractionGroup,
                  focusedBoundingBoxId: extraction.result.id,
                },
              ]);
            }}
          />
        );
      })}
    </Container>
  );
};

export default OverlappingExtractionHoverCard;
